import i18n from "../i18n";

type ApiErrorPayload = {
  status?: number | string;
  data?: unknown;
  error?: string;
  originalStatus?: number;
};

const errorTranslationKeys = {
  "400": "common:errors.server.400",
  "401": "common:errors.server.401",
  "403": "common:errors.server.403",
  "404": "common:errors.server.404",
  "405": "common:errors.server.405",
  "422": "common:errors.server.422",
  "500": "common:errors.server.500",
  "502": "common:errors.server.502",
  "503": "common:errors.server.503",
  "504": "common:errors.server.504",
  PARSING_ERROR: "common:errors.server.PARSING_ERROR",
  FETCH_ERROR: "common:errors.server.FETCH_ERROR",
  TIMEOUT_ERROR: "common:errors.server.TIMEOUT_ERROR",
  CUSTOM_ERROR: "common:errors.server.CUSTOM_ERROR",
} as const;

const messagesFromData = (data: unknown): string[] => {
  if (!data || typeof data !== "object" || Array.isArray(data)) return [];

  const values = data as Record<string, unknown>;
  const messages: string[] = [];
  if (typeof values.error === "string" && values.error.trim())
    messages.push(values.error.trim());
  if (typeof values.message === "string" && values.message.trim()) {
    messages.push(values.message.trim());
  } else if (Array.isArray(values.message)) {
    messages.push(
      ...values.message.filter(
        (value): value is string => typeof value === "string",
      ),
    );
  }

  Object.entries(values).forEach(([key, value]) => {
    if (key !== "message" && Array.isArray(value)) {
      messages.push(
        ...value.filter((item): item is string => typeof item === "string"),
      );
    }
  });
  return Array.from(new Set(messages));
};

export const getApiErrorMessages = (payload: unknown): string[] => {
  const error = (payload || {}) as ApiErrorPayload;
  const businessMessages = messagesFromData(error.data);
  if (businessMessages.length) return businessMessages;

  const status = String(error.status || "");
  const translationKey = Object.prototype.hasOwnProperty.call(
    errorTranslationKeys,
    status,
  )
    ? errorTranslationKeys[status as keyof typeof errorTranslationKeys]
    : "common:errors.server.fallback";
  return [String(i18n.t(translationKey))];
};
